import {ChangeDetectorRef, Component, HostListener, ViewEncapsulation} from '@angular/core';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {CrystalClearFrontUrl} from '../../../shared/pages/crystal-clear-front-url';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../../model/security/user';
import {RoutingData} from '../../../routing/routing-data';
import {HeaderActionService} from '../../../services/header-action.service';
import {ToastService} from '../../../services/toast-service';
import {MenuItem, MessageService} from 'primeng/api';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Locale} from '../../../utils/locale';
import {PageDescription} from "../../../shared/pages/page-description";
import {ThemeService} from "../../../services/tools/theme.service";
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {CcStorageService} from "../../../services/common/cc-storage.service";


@Component({
  template: '',
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslateService,
  ]
})
export class HeaderMenuBaseComponent extends CcBaseComponent {

  display: boolean = false;

  isAuthenticated: boolean;
  userInfo: User;

  router: Router;
  menuBarItemsLeft: MenuItem[] = [];
  menuBarItemsRight: MenuItem[] = [];

  userFormVisible: boolean = false;
  helpDialogVisible: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              private authService: UserInfoStorageService,
              router: Router,
              private headerActionService: HeaderActionService,
              private route: ActivatedRoute,
              private toastService: ToastService,
              translateService: TranslateService,
              private storageService: CcStorageService,
              public themeService: ThemeService) {
    super(cdref, messageService, translateService);
    this.router = router;
    translateService.addLangs([Locale.LANGS.EN_GB.id]);
    translateService.setDefaultLang(Locale.LANGS.EN_GB.id);
    translateService.use(Locale.LANGS.EN_GB.id);
    themeService.initTheme();
  }

  logInOut() {
    if (this.isAuthenticated) {
      this.authService.logout();
      this.router.navigate(['/' + CrystalClearFrontUrl.LOGIN.path]);
    } else {
      const extras = [];
      extras[RoutingData.Extras.REDIRECT_TO] = this.router.url;
      this.router.navigate(['/' + CrystalClearFrontUrl.LOGIN.path], {queryParams: extras});
    }
  }

  getUserInformation() {
    if (this.authService.isAuthenticated) {
      this.authService.refreshConnectedUserCacheInfo().subscribe(userInfo => {
          this.userInfo = userInfo ? Object.assign(new User(), userInfo) : null;
      if (!this.userInfo) {
        this.logInOut();
      }
      this.initMenuItems();
        }
        // , error => {
        //   this.isAuthenticated = this.authService.isAuthenticated;
        //   Zone.current.run(() => {
        //       console.log("-----> getUserInformation " + this.isAuthenticated);
        //       // this.router.routeReuseStrategy.shouldReuseRoute = function () {
        //       //   return false;
        //       // }
        //       // this.router.onSameUrlNavigation = 'reload';
        //       const extras = [];
        //       extras[RoutingData.Extras.REDIRECT_TO] = this.router.url;
        //       this.router.navigate(['/' + CrystalClearFrontUrl.LOGIN.path], {queryParams: extras});
        //     }
        //   );
        // }
      );
    } else {
      this.logInOut();
    }
  }

  ngOnInit(): void {

    this.authService.setLangFromStorage();

    this.getUserInformation();

    this.isAuthenticated = this.authService.isAuthenticated;

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initMenuItems();
    });
  }

  protected initMenuItems() {
  }

  protected toMenuItem(pDesc: PageDescription, iconOnly: boolean, subItems: MenuItem[] = [], enabled: boolean = true): MenuItem {
    const menu: MenuItem = PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, this.userInfo.roles, iconOnly, subItems, enabled);
    if (pDesc.path) {
      menu.command = () => {
        this.router.navigate([pDesc.path]);
        this.refreshActiveMenu(pDesc.path);
        this.markForCheck();
      };
    }
    return menu;
  }

  refreshActiveMenu(path: string) {
    this.menuBarItemsLeft.forEach(menu => {
      let isActive: boolean = path === menu.id;
      menu.styleClass = menu.styleClass.replace(' cc-active', '');
      if (isActive) {
        menu.styleClass += ' cc-active';
      }
    })
    this.menuBarItemsRight.forEach(menu => {
      let isActive: boolean = path === menu.id;
      menu.styleClass = menu.styleClass.replace(' cc-active', '');
      if (isActive) {
        menu.styleClass += ' cc-active';
      }
    })
    this.menuBarItemsLeft = [...this.menuBarItemsLeft];
    this.menuBarItemsRight = [...this.menuBarItemsRight];
  }

  protected updateUser(user: User) {
    this.getUserInformation();
  }

  @HostListener('document:keydown.control.alt.shift.x', ['$event'])
  shiftRepeatX(e) {
    this.storageService.deleteAll();
    this.infoMessage("All cookies have been digested");
  }

  protected toggleTheme() {
    this.themeService.toggle()
  }
}

